'use client'

import { ReactBrowserRuntimeProvider } from '#runtime/browser.runtime.ts'

function BrowserRuntimeProvider({ children }: React.PropsWithChildren) {
  return <ReactBrowserRuntimeProvider>{children}</ReactBrowserRuntimeProvider>
}

export default BrowserRuntimeProvider
